import React, { useState } from 'react';
import {
  FDBodyText, FDClickableText, FDDialog, FDDialogContent, FDDialogTitle, FDStack,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import useMobileLayout from 'Hooks/useMobileLayout';
import UpdatedScenarioChart from 'Organisms/UpdatedScenarioChart';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  CustomizationToggle,
} from 'Views/Page/Content/Templates/WizardTemplates/EstatePlanningRecommendation/Components';
import { capitalizeWord } from 'Helpers/Formats';

const metaOverrideSet = buildFacetDesignOverride();

const useStyles = buildUseStyles('TaxSavingsChart', () => ({
  chartInfo: {
    '& .FD-MuiTypography-root': {
      display: 'inline-block',
    },
  },
}));

export const TaxSavingsChart = ({ resource, fixedWidth }) => {
  const classes = useStyles();
  const options = Object.keys(resource.attributes())
    .filter(fieldName => fieldName.endsWith('Chart'))
    .map(fieldName => fieldName.replace('Chart', ''))
    .map(name => ({ name: capitalizeWord(name), value: name }));

  const [optionToShow, setOptionToShow] = useState(options[0]?.value);
  const chart = resource.attr(`${optionToShow}Chart`)?.resources()?.head();
  const chartTitle = resource.attr(`${optionToShow}ChartTitle`);
  const [showHowToReadChart, setShowHowToReadChart] = useState(false);
  const isMobile = useMobileLayout();

  if (options.length === 0) {
    return null;
  }
  return (
    <FDStack direction="column" alignItems="center" minWidth={0} spacing={4}>
      <FDDialog
        open={showHowToReadChart}
        onClose={() => setShowHowToReadChart(false)}
        closeOnBackdropClick
        dialogWidth="sm"
        fullScreen={isMobile}
      >
        <FDDialogTitle value="How to read the chart" />
        <FDDialogContent>
          <MetaControl
            attrName={`${optionToShow}ChartDetails`}
            resource={resource}
            metaOverrideSet={metaOverrideSet}
          />
        </FDDialogContent>
      </FDDialog>
      <CustomizationToggle value={optionToShow} options={options} onChange={setOptionToShow} />
      {chartTitle ? (
        <FDBodyText
          value={(
            <div className={classes.chartInfo}>
              {chartTitle}
              &nbsp;
              <FDBodyText
                color="textSecondary"
                value={(
                  <FDClickableText
                    appearance="standalone"
                    onClick={() => setShowHowToReadChart(true)}
                    label="Learn more"
                  />
                )}
              />
            </div>
          )}
        />
      ) : null
    }
      {
        chart ? (
          <FDStack direction="row" justifyContent="center" width="100%">
            <FDStack
              direction="column"
              height={300}
              width={fixedWidth ? 500 : '100%'}
              maxWidth={chart.isTruthy('allowThickBarChart') ? 500 : undefined}
            >
              <UpdatedScenarioChart chartDataResource={chart} showLegend />
            </FDStack>
          </FDStack>
        ) : null
      }
    </FDStack>
  );
};
